import React from 'react';
import { motion } from 'framer-motion';
import { MapPin, Phone, Clock, ArrowRight } from 'lucide-react';
export function CTASection() {
  return <section id="reserva" className="py-24 px-6 bg-cream relative overflow-hidden" data-id="element-34">
      {/* Decorative elements */}
      <div className="absolute top-0 right-0 w-64 h-64 bg-gold/10 rounded-full blur-3xl" data-id="element-35" />
      <div className="absolute bottom-0 left-0 w-64 h-64 bg-gold/10 rounded-full blur-3xl" data-id="element-36" />

      <div className="max-w-4xl mx-auto relative z-10" data-id="element-37">
        <div className="bg-white p-8 md:p-16 rounded-sm shadow-2xl border border-gold/20 text-center" data-id="element-38">
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} className="text-4xl md:text-5xl font-serif text-ink mb-4" data-id="element-39">
            Reserva Tu Cita Ahora
          </motion.h2>

          <motion.p initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: 0.1
        }} className="font-sans text-ink-light mb-12" data-id="element-40">
            Escríbele directamente a Ingri y asegura tu lugar:
          </motion.p>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} className="grid sm:grid-cols-3 gap-8 mb-12" data-id="element-41">
            <div className="flex flex-col items-center gap-3" data-id="element-42">
              <div className="w-12 h-12 rounded-full bg-cream flex items-center justify-center" data-id="element-43">
                <MapPin className="text-gold" size={20} data-id="element-44" />
              </div>
              <div className="font-sans text-sm text-ink font-bold" data-id="element-45">
                Ubicación
              </div>
              <div className="font-sans text-sm text-ink-light" data-id="element-46">
                910 Fairmont Pkwy,
                <br data-id="element-47" />
                Pasadena, TX 77504
              </div>
            </div>

            <div className="flex flex-col items-center gap-3" data-id="element-48">
              <div className="w-12 h-12 rounded-full bg-cream flex items-center justify-center" data-id="element-49">
                <Phone className="text-gold" size={20} data-id="element-50" />
              </div>
              <div className="font-sans text-sm text-ink font-bold" data-id="element-51">
                Teléfono
              </div>
              <div className="font-sans text-sm text-ink-light" data-id="element-52">
                +1 (929) 544-1537
              </div>
            </div>

            <div className="flex flex-col items-center gap-3" data-id="element-53">
              <div className="w-12 h-12 rounded-full bg-cream flex items-center justify-center" data-id="element-54">
                <Clock className="text-gold" size={20} data-id="element-55" />
              </div>
              <div className="font-sans text-sm text-ink font-bold" data-id="element-56">
                Horario
              </div>
              <div className="font-sans text-sm text-ink-light" data-id="element-57">
                Martes a Sábados
                <br data-id="element-58" />
                10am – 4pm
              </div>
            </div>
          </motion.div>

          <motion.a initial={{
          opacity: 0,
          scale: 0.95
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: 0.4
        }} href="tel:+19295441537" className="inline-flex items-center justify-center gap-3 bg-gold text-white w-full md:w-auto px-12 py-5 text-sm uppercase tracking-widest hover:bg-gold-dark transition-all duration-300 shadow-lg hover:shadow-xl hover:-translate-y-1 group font-bold" data-id="element-59">
            Reservar Mi Cita Ahora
            <ArrowRight size={18} className="group-hover:translate-x-1 transition-transform" data-id="element-60" />
          </motion.a>

          <p className="mt-8 font-serif italic text-ink-light" data-id="element-61">
            "Porque tu mirada merece una artista, no una improvisación."
          </p>
        </div>
      </div>
    </section>;
}